import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useState } from "react";
import Image from "next/image";
import { Ui, http } from "@silvertours/front-shared";
import { Runtime, account, analytics } from "@silvertours/front-entities";
import { StyledForm, TitleWrapper, Title, InputWrapper, PasswordLostWrapper, Footer as StyledFooter, SwirlWrapper, SubmitButton, FormActionArea, MaxWidthWrapper } from "./LoginForm.styles";
import Swirl from "./swirl.png";
import { LoginError } from "./LoginError";
import { useLogin } from "./LoginState";
import { Footer } from "./Footer";
var LoginForm = function(param) {
    var withinModal = param.withinModal, translations = param.translations;
    var actionPath = translations.actionPath, emailLabel = translations.emailLabel, loginTitle = translations.loginTitle, error = translations.error, passwordLabel = translations.passwordLabel, passwordLostHref = translations.passwordLostHref, passwordLostText = translations.passwordLostText, submitText = translations.submitText;
    var ref = useState(false), loading = ref[0], setLoading = ref[1];
    var ref1 = useLogin(), setUsername = ref1.setUsername, setShowLogin = ref1.setShowLogin, setLoggedIn = ref1.setLoggedIn, setError = ref1.setError, securityToken = ref1.securityToken;
    var whitelabel = Runtime.useWhitelabel().whitelabel;
    var isLoggedIn = false;
    var ref2 = Runtime.useAccountConfig(), formatApiUrl = ref2.formatApiUrl, formatSessionUrl = ref2.formatSessionUrl;
    var handleSubmit = function() {
        var _ref = _async_to_generator(function(event) {
            var emailAddress, password, ref, loggedIn, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        emailAddress = event.currentTarget.elements.namedItem("emailAddress").value;
                        password = event.currentTarget.elements.namedItem("password").value;
                        setUsername(emailAddress);
                        setLoading(true);
                        return [
                            4,
                            account.login(formatApiUrl(http.API.accountLogin), formatSessionUrl(http.API.accountSession), emailAddress, password, whitelabel)
                        ];
                    case 1:
                        ref = _state.sent(), loggedIn = ref.loggedIn, errorMessage = ref.error;
                        if (loggedIn) {
                            setShowLogin(false);
                            setLoggedIn(true);
                        } else {
                            setError(errorMessage || null);
                            setLoggedIn(false);
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(StyledForm, {
                method: "post",
                action: actionPath,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "hidden",
                        name: "securityToken",
                        value: securityToken
                    }),
                    /*#__PURE__*/ _jsx(SwirlWrapper, {
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: Swirl,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ _jsx(TitleWrapper, {
                        children: /*#__PURE__*/ _jsx(Title, {
                            children: loginTitle
                        })
                    }),
                    /*#__PURE__*/ _jsx(LoginError, {
                        translations: error
                    }),
                    /*#__PURE__*/ _jsx(FormActionArea, {
                        children: /*#__PURE__*/ _jsxs(MaxWidthWrapper, {
                            children: [
                                /*#__PURE__*/ _jsx(InputWrapper, {
                                    children: /*#__PURE__*/ _jsx(Ui.Input, {
                                        id: "email",
                                        type: "email",
                                        name: "emailAddress",
                                        label: emailLabel,
                                        autoComplete: "section-login username",
                                        autoCorrect: "off",
                                        autoCapitalize: "off",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx(InputWrapper, {
                                    children: /*#__PURE__*/ _jsx(Ui.Input, {
                                        id: "password",
                                        type: "password",
                                        name: "password",
                                        label: passwordLabel,
                                        autoComplete: "section-login current-password",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx(PasswordLostWrapper, {
                                    children: /*#__PURE__*/ _jsx(Ui.TextLink, {
                                        href: passwordLostHref,
                                        text: passwordLostText,
                                        onClick: function() {
                                            return analytics.gtm.trackPasswordForgotten({
                                                isLoggedIn: isLoggedIn
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SubmitButton, {
                                    type: "submit",
                                    loading: loading,
                                    disabled: loading,
                                    onClick: analytics.gtm.trackLogin,
                                    fullWidth: true,
                                    children: submitText
                                })
                            ]
                        })
                    })
                ]
            }),
            !withinModal && /*#__PURE__*/ _jsx(StyledFooter, {
                children: /*#__PURE__*/ _jsx(Footer, {
                    translations: translations,
                    isLoggedIn: isLoggedIn
                })
            })
        ]
    });
};
export { LoginForm };
